module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_suns_black-ab185661c59f263e744e709dddfb33bb.svg";